var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mod mod-success"},[_vm._m(0),_c('div',{staticClass:"action"},[_c('a-button',{staticClass:"full-btn",attrs:{"size":"large","type":"primary"},on:{"click":_vm.onBack}},[_vm._v("我知道了")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("您的预约已提交成功，如航班开航，祥鹏航空将通知您进行航班预定，请您注意查收短信。")])])
}]

export { render, staticRenderFns }